export default class InsuranceType {
  id: string
  text: string
  default: boolean
  disabled: boolean

  constructor(data: any = {}) {
    this.id = data.id
    this.text = data.text
    this.default = data.default
    this.disabled = data.disabled
  }
}
